'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.featureFlagReducer = exports.setupFeatureFlags = exports.SETUP_FEATURE_FLAGS = exports.loadIdentityToSplitio = exports.LOAD_IDENTITY = exports.loadTreatment = exports.SET_FEATURE_FLAG = exports.treatmentsSelector = exports.identitySelector = undefined;

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends3 = require('babel-runtime/helpers/extends');

var _extends4 = _interopRequireDefault(_extends3);

var _splitio = require('./splitio');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var identitySelector = exports.identitySelector = function identitySelector(state) {
  var reducer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'flags';
  return state[reducer] ? state[reducer].identity : null;
};

var treatmentsSelector = exports.treatmentsSelector = function treatmentsSelector(state) {
  var reducer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'flags';
  return state[reducer] ? state[reducer].treatments : null;
};

var SET_FEATURE_FLAG = exports.SET_FEATURE_FLAG = 'SET_FEATURE_FLAG';

var loadTreatment = exports.loadTreatment = function loadTreatment(treatment) {
  var reducer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'flags';
  return function (dispatch, getState) {
    var state = getState();
    var treatments = treatmentsSelector(state, reducer) || {};
    var existingTreatment = treatments[treatment];

    if (existingTreatment) return existingTreatment;

    var identity = identitySelector(state, reducer) || { id: 'unidentified' };
    var value = (0, _splitio.getTreatment)(treatment, identity);
    dispatch({
      type: SET_FEATURE_FLAG,
      treatment: treatment,
      value: value
    });
    return value;
  };
};

var LOAD_IDENTITY = exports.LOAD_IDENTITY = 'LOAD_IDENTITY';

var loadIdentityToSplitio = exports.loadIdentityToSplitio = function loadIdentityToSplitio(store, identity) {
  return store.dispatch({ type: LOAD_IDENTITY, identity: identity });
};

var SETUP_FEATURE_FLAGS = exports.SETUP_FEATURE_FLAGS = 'SETUP_FEATURE_FLAGS';

var setupFeatureFlags = exports.setupFeatureFlags = function setupFeatureFlags(identity) {
  for (var _len = arguments.length, treatmentKeys = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    treatmentKeys[_key - 1] = arguments[_key];
  }

  return function (dispatch) {
    var treatments = {};
    treatmentKeys.forEach(function (treatment) {
      treatments[treatment] = (0, _splitio.getTreatment)(treatment, identity);
    });
    dispatch({
      type: SETUP_FEATURE_FLAGS,
      treatments: treatments
    });
  };
};

var featureFlagReducer = exports.featureFlagReducer = function featureFlagReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments[1];

  if (action && action.type) {
    switch (action.type) {
      case LOAD_IDENTITY:
        return (0, _extends4.default)({}, state, {
          identity: action.identity
        });

      case SET_FEATURE_FLAG:
        return (0, _extends4.default)({}, state, {
          treatments: (0, _extends4.default)({}, state.treatments, (0, _defineProperty3.default)({}, action.treatment, action.value))
        });

      case SETUP_FEATURE_FLAGS:
        return (0, _extends4.default)({}, state, {
          treatments: action.treatments
        });

      default:
        return state;
    }
  }

  return state;
};


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/web-common/dist/features/redux.js
// module id = 743
// module chunks = 10